/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseError } from '../types';
// @ts-ignore
import type { CreateWidgetBody } from '../types';
// @ts-ignore
import type { GetPublishedWidgetData200Response } from '../types';
// @ts-ignore
import type { MapLayerData } from '../types';
// @ts-ignore
import type { PublishedWidget } from '../types';
// @ts-ignore
import type { UpdateWidgetBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
// @ts-ignore
import type { Widget } from '../types';
/**
 * WidgetsApi - axios parameter creator
 * @export
 */
export const WidgetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new widget on a page using a default position (appended to the bottom-left) and size for the widget container, or alternatively, appending it to an existing widget container by ID.
         * @summary Create a Widget
         * @param {string} pageId 
         * @param {CreateWidgetBody} [createWidgetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidget: async (pageId: string, createWidgetBody?: CreateWidgetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('createWidget', 'pageId', pageId)
            const localVarPath = `/pages/{page_id}/widgets`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWidgetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a widget. If the widget was the last one in its widget container, the widget container is deleted too.
         * @summary Delete an existing Widget
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidget: async (widgetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('deleteWidget', 'widgetId', widgetId)
            const localVarPath = `/widgets/{widget_id}`
                .replace(`{${"widget_id"}}`, encodeURIComponent(String(widgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a widget container and all its widgets.
         * @summary Delete an existing WidgetContainer
         * @param {string} widgetContainerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetContainer: async (widgetContainerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetContainerId' is not null or undefined
            assertParamExists('deleteWidgetContainer', 'widgetContainerId', widgetContainerId)
            const localVarPath = `/widget_containers/{widget_container_id}`
                .replace(`{${"widget_container_id"}}`, encodeURIComponent(String(widgetContainerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for the latest published version of a MapLayer
         * @summary Get data for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} timeStart 
         * @param {string} timeEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedMapLayerData: async (dashboardId: string, mapLayerId: string, timeStart: string, timeEnd: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPublishedMapLayerData', 'dashboardId', dashboardId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getPublishedMapLayerData', 'mapLayerId', mapLayerId)
            // verify required parameter 'timeStart' is not null or undefined
            assertParamExists('getPublishedMapLayerData', 'timeStart', timeStart)
            // verify required parameter 'timeEnd' is not null or undefined
            assertParamExists('getPublishedMapLayerData', 'timeEnd', timeEnd)
            const localVarPath = `/published/dashboards/{dashboard_id}/map_layers/{map_layer_id}/data`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeStart !== undefined) {
                localVarQueryParameter['time_start'] = timeStart;
            }

            if (timeEnd !== undefined) {
                localVarQueryParameter['time_end'] = timeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get legend graphic (image)
         * @summary Get legend graphic for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedMapLayerLegendGraphic: async (dashboardId: string, mapLayerId: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPublishedMapLayerLegendGraphic', 'dashboardId', dashboardId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getPublishedMapLayerLegendGraphic', 'mapLayerId', mapLayerId)
            const localVarPath = `/published/dashboards/{dashboard_id}/map_layers/{map_layer_id}/legend`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dimensionTime !== undefined) {
                localVarQueryParameter['dimension_time'] = dimensionTime;
            }

            if (dimensionReferenceTime !== undefined) {
                localVarQueryParameter['dimension_reference_time'] = dimensionReferenceTime;
            }

            if (dimensionAircraftHeightAboveGroundLevelInFt !== undefined) {
                localVarQueryParameter['dimension_aircraft_height_above_ground_level_in_ft'] = dimensionAircraftHeightAboveGroundLevelInFt;
            }

            if (dimensionLevel !== undefined) {
                localVarQueryParameter['dimension_level'] = dimensionLevel;
            }

            if (dimensionRiskProfile !== undefined) {
                localVarQueryParameter['dimension_risk_profile'] = dimensionRiskProfile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for the latest published version of a widget
         * @summary Get data for widget by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {string} [locationId] 
         * @param {string} [timeStart] 
         * @param {string} [timeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedWidgetData: async (dashboardId: string, widgetId: string, locationId?: string, timeStart?: string, timeEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPublishedWidgetData', 'dashboardId', dashboardId)
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('getPublishedWidgetData', 'widgetId', widgetId)
            const localVarPath = `/published/dashboards/{dashboard_id}/widgets/{widget_id}/data`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"widget_id"}}`, encodeURIComponent(String(widgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (timeStart !== undefined) {
                localVarQueryParameter['time_start'] = timeStart;
            }

            if (timeEnd !== undefined) {
                localVarQueryParameter['time_end'] = timeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest published version of a widget for a dashboard
         * @summary Find widget for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetForPublishedDashboard: async (dashboardId: string, widgetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getWidgetForPublishedDashboard', 'dashboardId', dashboardId)
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('getWidgetForPublishedDashboard', 'widgetId', widgetId)
            const localVarPath = `/published/dashboards/{dashboard_id}/widgets/{widget_id}`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"widget_id"}}`, encodeURIComponent(String(widgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get WMS tile
         * @summary Get WMS tile for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} crs 
         * @param {string} bbox 
         * @param {string} width 
         * @param {string} height 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet: async (dashboardId: string, mapLayerId: string, crs: string, bbox: string, width: string, height: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'dashboardId', dashboardId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'mapLayerId', mapLayerId)
            // verify required parameter 'crs' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'crs', crs)
            // verify required parameter 'bbox' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'bbox', bbox)
            // verify required parameter 'width' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'width', width)
            // verify required parameter 'height' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'height', height)
            const localVarPath = `/published/dashboards/{dashboard_id}/map_layers/{map_layer_id}/wms_tile`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (crs !== undefined) {
                localVarQueryParameter['crs'] = crs;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (width !== undefined) {
                localVarQueryParameter['width'] = width;
            }

            if (height !== undefined) {
                localVarQueryParameter['height'] = height;
            }

            if (dimensionTime !== undefined) {
                localVarQueryParameter['dimension_time'] = dimensionTime;
            }

            if (dimensionReferenceTime !== undefined) {
                localVarQueryParameter['dimension_reference_time'] = dimensionReferenceTime;
            }

            if (dimensionAircraftHeightAboveGroundLevelInFt !== undefined) {
                localVarQueryParameter['dimension_aircraft_height_above_ground_level_in_ft'] = dimensionAircraftHeightAboveGroundLevelInFt;
            }

            if (dimensionLevel !== undefined) {
                localVarQueryParameter['dimension_level'] = dimensionLevel;
            }

            if (dimensionRiskProfile !== undefined) {
                localVarQueryParameter['dimension_risk_profile'] = dimensionRiskProfile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorders all widgets for widget container.
         * @summary Reorder all widgets for widget container by ID
         * @param {string} widgetContainerId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWidgetsForWidgetContainer: async (widgetContainerId: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetContainerId' is not null or undefined
            assertParamExists('reorderWidgetsForWidgetContainer', 'widgetContainerId', widgetContainerId)
            const localVarPath = `/widget_containers/{widget_container_id}/widgets/order`
                .replace(`{${"widget_container_id"}}`, encodeURIComponent(String(widgetContainerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a widget.
         * @summary Update an existing widget
         * @param {string} widgetId 
         * @param {UpdateWidgetBody} [updateWidgetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidget: async (widgetId: string, updateWidgetBody?: UpdateWidgetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('updateWidget', 'widgetId', widgetId)
            const localVarPath = `/widgets/{widget_id}`
                .replace(`{${"widget_id"}}`, encodeURIComponent(String(widgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWidgetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WidgetsApi - functional programming interface
 * @export
 */
export const WidgetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WidgetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new widget on a page using a default position (appended to the bottom-left) and size for the widget container, or alternatively, appending it to an existing widget container by ID.
         * @summary Create a Widget
         * @param {string} pageId 
         * @param {CreateWidgetBody} [createWidgetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWidget(pageId: string, createWidgetBody?: CreateWidgetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Widget>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWidget(pageId, createWidgetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.createWidget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a widget. If the widget was the last one in its widget container, the widget container is deleted too.
         * @summary Delete an existing Widget
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWidget(widgetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWidget(widgetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.deleteWidget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a widget container and all its widgets.
         * @summary Delete an existing WidgetContainer
         * @param {string} widgetContainerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWidgetContainer(widgetContainerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWidgetContainer(widgetContainerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.deleteWidgetContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns data for the latest published version of a MapLayer
         * @summary Get data for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} timeStart 
         * @param {string} timeEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedMapLayerData(dashboardId: string, mapLayerId: string, timeStart: string, timeEnd: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MapLayerData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedMapLayerData(dashboardId, mapLayerId, timeStart, timeEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.getPublishedMapLayerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get legend graphic (image)
         * @summary Get legend graphic for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedMapLayerLegendGraphic(dashboardId: string, mapLayerId: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedMapLayerLegendGraphic(dashboardId, mapLayerId, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.getPublishedMapLayerLegendGraphic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns data for the latest published version of a widget
         * @summary Get data for widget by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {string} [locationId] 
         * @param {string} [timeStart] 
         * @param {string} [timeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedWidgetData(dashboardId: string, widgetId: string, locationId?: string, timeStart?: string, timeEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublishedWidgetData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedWidgetData(dashboardId, widgetId, locationId, timeStart, timeEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.getPublishedWidgetData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the latest published version of a widget for a dashboard
         * @summary Find widget for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetForPublishedDashboard(dashboardId: string, widgetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishedWidget>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetForPublishedDashboard(dashboardId, widgetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.getWidgetForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get WMS tile
         * @summary Get WMS tile for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} crs 
         * @param {string} bbox 
         * @param {string} width 
         * @param {string} height 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId: string, mapLayerId: string, crs: string, bbox: string, width: string, height: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId, mapLayerId, crs, bbox, width, height, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reorders all widgets for widget container.
         * @summary Reorder all widgets for widget container by ID
         * @param {string} widgetContainerId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderWidgetsForWidgetContainer(widgetContainerId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderWidgetsForWidgetContainer(widgetContainerId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.reorderWidgetsForWidgetContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a widget.
         * @summary Update an existing widget
         * @param {string} widgetId 
         * @param {UpdateWidgetBody} [updateWidgetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWidget(widgetId: string, updateWidgetBody?: UpdateWidgetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Widget>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWidget(widgetId, updateWidgetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetsApi.updateWidget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WidgetsApi - factory interface
 * @export
 */
export const WidgetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WidgetsApiFp(configuration)
    return {
        /**
         * Creates a new widget on a page using a default position (appended to the bottom-left) and size for the widget container, or alternatively, appending it to an existing widget container by ID.
         * @summary Create a Widget
         * @param {string} pageId 
         * @param {CreateWidgetBody} [createWidgetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidget(pageId: string, createWidgetBody?: CreateWidgetBody, options?: RawAxiosRequestConfig): AxiosPromise<Widget> {
            return localVarFp.createWidget(pageId, createWidgetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a widget. If the widget was the last one in its widget container, the widget container is deleted too.
         * @summary Delete an existing Widget
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidget(widgetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWidget(widgetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a widget container and all its widgets.
         * @summary Delete an existing WidgetContainer
         * @param {string} widgetContainerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetContainer(widgetContainerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWidgetContainer(widgetContainerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for the latest published version of a MapLayer
         * @summary Get data for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} timeStart 
         * @param {string} timeEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedMapLayerData(dashboardId: string, mapLayerId: string, timeStart: string, timeEnd: string, options?: RawAxiosRequestConfig): AxiosPromise<MapLayerData> {
            return localVarFp.getPublishedMapLayerData(dashboardId, mapLayerId, timeStart, timeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Get legend graphic (image)
         * @summary Get legend graphic for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedMapLayerLegendGraphic(dashboardId: string, mapLayerId: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getPublishedMapLayerLegendGraphic(dashboardId, mapLayerId, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for the latest published version of a widget
         * @summary Get data for widget by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {string} [locationId] 
         * @param {string} [timeStart] 
         * @param {string} [timeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedWidgetData(dashboardId: string, widgetId: string, locationId?: string, timeStart?: string, timeEnd?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPublishedWidgetData200Response> {
            return localVarFp.getPublishedWidgetData(dashboardId, widgetId, locationId, timeStart, timeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest published version of a widget for a dashboard
         * @summary Find widget for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetForPublishedDashboard(dashboardId: string, widgetId: string, options?: RawAxiosRequestConfig): AxiosPromise<PublishedWidget> {
            return localVarFp.getWidgetForPublishedDashboard(dashboardId, widgetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get WMS tile
         * @summary Get WMS tile for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} crs 
         * @param {string} bbox 
         * @param {string} width 
         * @param {string} height 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId: string, mapLayerId: string, crs: string, bbox: string, width: string, height: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId, mapLayerId, crs, bbox, width, height, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options).then((request) => request(axios, basePath));
        },
        /**
         * Reorders all widgets for widget container.
         * @summary Reorder all widgets for widget container by ID
         * @param {string} widgetContainerId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWidgetsForWidgetContainer(widgetContainerId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderWidgetsForWidgetContainer(widgetContainerId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a widget.
         * @summary Update an existing widget
         * @param {string} widgetId 
         * @param {UpdateWidgetBody} [updateWidgetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidget(widgetId: string, updateWidgetBody?: UpdateWidgetBody, options?: RawAxiosRequestConfig): AxiosPromise<Widget> {
            return localVarFp.updateWidget(widgetId, updateWidgetBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WidgetsApi - object-oriented interface
 * @export
 * @class WidgetsApi
 * @extends {BaseAPI}
 */
export class WidgetsApi extends BaseAPI {
    /**
     * Creates a new widget on a page using a default position (appended to the bottom-left) and size for the widget container, or alternatively, appending it to an existing widget container by ID.
     * @summary Create a Widget
     * @param {string} pageId 
     * @param {CreateWidgetBody} [createWidgetBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public createWidget(pageId: string, createWidgetBody?: CreateWidgetBody, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).createWidget(pageId, createWidgetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a widget. If the widget was the last one in its widget container, the widget container is deleted too.
     * @summary Delete an existing Widget
     * @param {string} widgetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public deleteWidget(widgetId: string, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).deleteWidget(widgetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a widget container and all its widgets.
     * @summary Delete an existing WidgetContainer
     * @param {string} widgetContainerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public deleteWidgetContainer(widgetContainerId: string, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).deleteWidgetContainer(widgetContainerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for the latest published version of a MapLayer
     * @summary Get data for MapLayer by ID
     * @param {string} dashboardId 
     * @param {string} mapLayerId 
     * @param {string} timeStart 
     * @param {string} timeEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public getPublishedMapLayerData(dashboardId: string, mapLayerId: string, timeStart: string, timeEnd: string, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).getPublishedMapLayerData(dashboardId, mapLayerId, timeStart, timeEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get legend graphic (image)
     * @summary Get legend graphic for MapLayer by ID
     * @param {string} dashboardId 
     * @param {string} mapLayerId 
     * @param {string} [dimensionTime] Required depending on layer
     * @param {string} [dimensionReferenceTime] Required depending on layer
     * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
     * @param {string} [dimensionLevel] Required depending on layer
     * @param {string} [dimensionRiskProfile] Required depending on layer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public getPublishedMapLayerLegendGraphic(dashboardId: string, mapLayerId: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).getPublishedMapLayerLegendGraphic(dashboardId, mapLayerId, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for the latest published version of a widget
     * @summary Get data for widget by ID
     * @param {string} dashboardId 
     * @param {string} widgetId 
     * @param {string} [locationId] 
     * @param {string} [timeStart] 
     * @param {string} [timeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public getPublishedWidgetData(dashboardId: string, widgetId: string, locationId?: string, timeStart?: string, timeEnd?: string, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).getPublishedWidgetData(dashboardId, widgetId, locationId, timeStart, timeEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the latest published version of a widget for a dashboard
     * @summary Find widget for published dashboard by ID
     * @param {string} dashboardId 
     * @param {string} widgetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public getWidgetForPublishedDashboard(dashboardId: string, widgetId: string, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).getWidgetForPublishedDashboard(dashboardId, widgetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get WMS tile
     * @summary Get WMS tile for MapLayer by ID
     * @param {string} dashboardId 
     * @param {string} mapLayerId 
     * @param {string} crs 
     * @param {string} bbox 
     * @param {string} width 
     * @param {string} height 
     * @param {string} [dimensionTime] Required depending on layer
     * @param {string} [dimensionReferenceTime] Required depending on layer
     * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
     * @param {string} [dimensionLevel] Required depending on layer
     * @param {string} [dimensionRiskProfile] Required depending on layer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId: string, mapLayerId: string, crs: string, bbox: string, width: string, height: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId, mapLayerId, crs, bbox, width, height, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reorders all widgets for widget container.
     * @summary Reorder all widgets for widget container by ID
     * @param {string} widgetContainerId 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public reorderWidgetsForWidgetContainer(widgetContainerId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).reorderWidgetsForWidgetContainer(widgetContainerId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a widget.
     * @summary Update an existing widget
     * @param {string} widgetId 
     * @param {UpdateWidgetBody} [updateWidgetBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public updateWidget(widgetId: string, updateWidgetBody?: UpdateWidgetBody, options?: RawAxiosRequestConfig) {
        return WidgetsApiFp(this.configuration).updateWidget(widgetId, updateWidgetBody, options).then((request) => request(this.axios, this.basePath));
    }
}

